import toast from "react-hot-toast";
import { FiCheck, FiAlertCircle } from "react-icons/fi";

const TOAST_CLASS = "app-toast";

const baseOptions = {
  duration: 5000,
};

const SuccessIcon = () => (
  <span className="app-toast-icon app-toast-icon--success" aria-hidden="true">
    <FiCheck strokeWidth={3} />
  </span>
);

const ErrorIcon = () => (
  <span className="app-toast-icon app-toast-icon--error" aria-hidden="true">
    <FiAlertCircle strokeWidth={2.5} />
  </span>
);

const showSuccessToast = (message) =>
  toast(message, {
    ...baseOptions,
    className: `${TOAST_CLASS} app-toast--success`,
    icon: <SuccessIcon />,
  });

const showErrorToast = (message) =>
  toast(message, {
    ...baseOptions,
    className: `${TOAST_CLASS} app-toast--error`,
    icon: <ErrorIcon />,
  });

export const showWelcomeCreditsClaimSuccess = (amount = 10) =>
  showSuccessToast(
    `${amount} welcome credit${amount === 1 ? "" : "s"} added. You're ready to create.`
  );

export const showCreditRequestSuccess = () =>
  showSuccessToast("Request received. More credits coming soon.");

export const showCreditRequestError = () =>
  showErrorToast("Something went wrong. Try again.");

export const appToastOptions = {
  duration: 5000,
};
